import { useAuthentication } from '@/hooks/useAuthentication';
import { Box, Text, useBreakpointValue } from '@chakra-ui/react';
import { formatAddress } from '@onbeam/utils';
import { LoadingDots } from '@sphere/ui';
import useTranslation from 'next-translate/useTranslation';
import { rem } from 'polished';

export const UserButtonContent = () => {
  const { t } = useTranslation('common');
  const { user, isAuthenticated, isAuthenticating } = useAuthentication();
  const isMobile = useBreakpointValue({ base: true, lg: false });

  if (isMobile) return null;

  if (isAuthenticating) {
    return (
      <Box w={rem(88)} mr="space.12">
        <LoadingDots />
      </Box>
    );
  }

  if (isAuthenticated) {
    return (
      <Text as="span" noOfLines={1} maxWidth={rem(128)} whiteSpace="normal" pr="space.12">
        {user?.name || formatAddress(user?.address || '')}
      </Text>
    );
  }

  return (
    <Text
      as="span"
      fontSize="xs"
      lineHeight="xs"
      textAlign="left"
      whiteSpace="nowrap"
      noOfLines={1}
      pr="space.20"
    >
      <Text as="strong" fontSize="sm" fontWeight="bold" mb="space.2" noOfLines={1}>
        {t('header.sign-in')}
      </Text>
      {t('header.connect-wallet')}
    </Text>
  );
};
